

export let refreshRateReadyPromise:Promise<number> = null;

function fallback(resolve) {
  let done = false;
  let begin = performance.now();
  let data = [];

  const onFrame = () => {
    if (!done) {
      requestAnimationFrame(onFrame);
    }

    const now = performance.now();
    // Remove any obvious outlier frames
    const diff = now - begin;
    if (diff < 34 && diff > 5) {
      data.push(diff);
    }
    begin = performance.now();
  };

  requestAnimationFrame(onFrame);

  setTimeout(() => {
    let avg = 0;
    let sampleCount = data.length;
    for (let i = 0; i < sampleCount; i++) {
      avg += data[i];
    }
    avg /= sampleCount;

    done = true;

    resolve(1000 / avg);
  }, 5000);
}

/// Measure the browser's refresh rate in the background,
/// fire a promise, returning the measured rate, once completed.
export function measureRefreshRate() {
  refreshRateReadyPromise = new Promise<number>((resolve) => {
    const worker = new Worker(HASH + "/worker.js");

    // Try to measure FPS in a web worker first.
    // If that fails, use our fallback method.
    worker.onmessage = (e) => {
      if (e.data == -1) {
        fallback(resolve);
      } else {
        resolve(e.data);
      }
    };

    worker.postMessage("");
  });
}